import { useEffect, useRef } from 'react';

interface Options<T> {
  clearOnErrorWithValue?: T;
}

function useUpdateOnDataReceived<T>(setData: (value: T) => void, value: T | undefined, error?: unknown, options?: Options<T>) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const setDataRef = useRef<(value: T) => void>(undefined!);
  setDataRef.current = setData;
  const optionsRef = useRef<Options<T>>();
  optionsRef.current = options;

  useEffect(
    () => {
      if (error !== undefined && optionsRef.current?.clearOnErrorWithValue !== undefined)
        setDataRef.current(optionsRef.current.clearOnErrorWithValue);
      else if (value !== undefined && value !== null)
        setDataRef.current(value);
    },
    [value, error],
  );
}

export default useUpdateOnDataReceived;